export const tipEnum = {
  FIXED: 0,
  PERCENT: 1,
};
